<template>
  <div class="page-header">
    <div class="container">
      <div class="row content">
        <div class="col-xs-12">
          <h1>
            Compare and switch in just four simple steps
          </h1>
          <p>
            Explore the market to find a cheaper, greener energy deal for you and your home
          </p>
          <slot></slot>
        </div>

        <div class="logo"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader'
};
</script>

<style lang="scss">
.page-header {
  background-color: $ut-bg;
  padding: 40px 0 30px 0;
  margin: 0;
  border-bottom: 3px solid $ut-blue;

  h1 {
    font-family: #{$font-family-heading};
    font-size: 40px;
    margin: 0 0 12px 0;
    line-height: 1.2;
    color: $ut-blue;
    font-weight: $font-weight-strong;
  }

  p {
    font-size: 18px;
    line-height: 1.5;
    color: $ut-text-muted;
    margin: 0;
    max-width: 42ch;
  }

  .content {
    position: relative;
    padding-right: 760px;

    .logo {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0, -50%);
      height: 144px;
      width: 680px;
      background: url('../../../assets/logo.png') no-repeat;
      background-size: contain;
      background-position: center right;
      display: inline-block;
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
    }

    p {
      font-size: 16px;
    }

    .content {
      padding-right: 0;
      padding-top: 200px;

      .logo {
        position: absolute;
        right: auto;
        left: 15px;
        top: 20px;
        transform: translate(0, 0);
        height: 112px;
        width: 520px;
        background-position: center left;
      }
    }
  }
}
</style>
